// extracted by mini-css-extract-plugin
export default {"version":"AppUpdatedModalContent-version-FNMj4","maintenance":"AppUpdatedModalContent-maintenance-icjTi","changes":"AppUpdatedModalContent-changes-pxSEa"};